import React, { useState, useEffect } from 'react';

import Dim from 'web/components/common/modal/common/Dim';
import Logo from 'web/components/common/modal/common/Logo';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';
import ScriptBox from 'web/components/common/modal/common/ScriptBox';
import VertifyPhone from 'web/components/common/modal/VertifyPhone';

import * as input from 'web/components/common/modal/common/input';
import classNames from 'classnames/bind';
import styles from './Join.scss';

const cx = classNames.bind(styles);

const Join = ({
  // value
  modal,
  username,
  password,
  nickname,
  marketing,
  phone,
  phoneCode,
  verification = {},
  error = {},

  // function
  handleChange,
  handleSubmit,
  handlePopup,
  handleBlur,
  handleMarketing,
  sendVerificationNumber,
  setJoinVerificationData,
  handleModal,
  getNickNameCheck,
}) => {
  const [mobile, setMobile] = useState(false);
  const [terms, setTerms] = useState(false);
  const [policy, setPolicy] = useState(false);

  useEffect(
    () => {
      // console.log(`@@@@@ `, error.phoneCode);
    },
    [error.phoneCode],
  );

  let joinStyle = {};
  if (mobile || terms || policy) {
    joinStyle.height = '450px';
  }

  const handleNext = () => {
    const compareList = ['username', 'nickname', 'password'];
    const falseList = compareList.filter(key =>
      verification[key] ? false : true,
    );

    // if (falseList.length)
    //   return document.getElementById(`input-${falseList[0]}`).focus();
    setMobile(true);
  };

  const joinCompareList = [
    'username',
    'nickname',
    'password',
    'phone',
    'phoneCode',
  ];
  const joinFalseList = joinCompareList.filter(key =>
    verification[key] ? false : true,
  );

  const handlePhoneVertificationInit = () => {
    setJoinVerificationData(
      { phone: null, phoneCode: null },
      { code: '', message: '', email: '' },
    );
    document.getElementById('input-phone').focus();
  };

  return (
    <Dim>
      <div
        className={cx('Join')}
        style={joinStyle}
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <Logo title={'가입하기'} />
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <input.Text
            key={`join-username`}
            type={'text'}
            name={'username'}
            value={username}
            validation={verification.username}
            error={error.username && error.username.message}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={`이메일`}
          />
          <input.Text
            key={`join-password`}
            type={'password'}
            name={'password'}
            value={password}
            validation={verification.password}
            error={error.password && error.password.message}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete={`off`}
            placeholder={`비밀번호 (8자 이상)`}
          />
          <input.Text
            key={`join-nickname`}
            type={'text'}
            name={'nickname'}
            value={nickname}
            validation={verification.nickname}
            error={error.nickname && error.nickname.message}
            onChange={handleChange}
            onBlur={handleBlur}
            autoComplete={`off`}
            placeholder={`닉네임을 입력해주세요.`}
          />

          <div className="question">
            <input.Checkbox
              name={`marketing-agree`}
              id={`marketing-agree`}
              value={marketing}
              msg={`닥터뮤지의 <span className="point">마케팅 정보 수신</span>에
              동의합니다.(선택)`}
              onChange={handleMarketing}
            />
            <div className="agree-guide">
              ‘동의하고 다음으로’ 버튼을 누름으로써 <br />
              <span className="link">
                <a
                  href={process.env.REACT_APP_TERMS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  이용약관
                </a>
              </span>
              과{' '}
              <span className="link">
                <a
                  href={process.env.REACT_APP_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  개인정보 처리 방침
                </a>
              </span>
              에 동의합니다.
            </div>
          </div>

          <div className="buttons">
            <input.Button type="button" onClick={handleNext}>
              다음으로
            </input.Button>
          </div>
        </form>

        <input.BottomButton
          msg={`이미 가입하셨다면`}
          onClick={() => handlePopup.login()}
        >
          기존 계정으로 로그인
        </input.BottomButton>

        <CloseBtn onClick={handlePopup.close} className={['btn-close']} />

        {/* 핸드폰 인증 */}
        <ScriptBox
          className={['mobile', `active-${mobile}`]}
          style={{ padding: '0' }}
        >
          <VertifyPhone
            modal={modal}
            type={`join`}
            active={mobile}
            phone={phone}
            phoneCode={phoneCode}
            verification={verification}
            error={error}
            falseList={joinFalseList}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleBack={() => {
              setMobile(false);
              document.getElementById('input-username').focus();
            }}
            handleInit={handlePhoneVertificationInit}
            handlePopup={handlePopup}
            sendVerificationNumber={sendVerificationNumber}
            handleSubmit={handleSubmit}
          />
        </ScriptBox>

        {/* 이용약관 */}
        {/* <ScriptBox
          className={['terms', `active-${terms}`]}
          title={`이용약관`}
          content={''}
        >
          <input.BottomButton
            msg={``}
            onClick={() => {
              setTerms(false);
              handleNext();
            }}
          >
            동의하고 다음으로
          </input.BottomButton>
        </ScriptBox> */}

        {/* 개인정보 취급방침 */}
        {/* <ScriptBox
          className={['policy', `active-${policy}`]}
          title={`개인정보 취급방침`}
          content={''}
        >
          <input.BottomButton
            msg={``}
            onClick={() => {
              setPolicy(false);
              handleNext();
            }}
          >
            동의하고 다음으로
          </input.BottomButton>
        </ScriptBox> */}
      </div>
    </Dim>
  );
};

export default Join;
